// @ts-nocheck
/* eslint-disable */

import { AllTypesProps, ReturnTypes, Ops } from './const';
export const HOST = "https://lnzuarqo4zeqrntgqis2ynyooy.appsync-api.us-east-1.amazonaws.com/graphql"


export const HEADERS = {}
export const apiSubscription = (options: chainOptions) => (query: string) => {
  try {
    const queryString = options[0] + '?query=' + encodeURIComponent(query);
    const wsString = queryString.replace('http', 'ws');
    const host = (options.length > 1 && options[1]?.websocket?.[0]) || wsString;
    const webSocketOptions = options[1]?.websocket || [host];
    const ws = new WebSocket(...webSocketOptions);
    return {
      ws,
      on: (e: (args: any) => void) => {
        ws.onmessage = (event: any) => {
          if (event.data) {
            const parsed = JSON.parse(event.data);
            const data = parsed.data;
            return e(data);
          }
        };
      },
      off: (e: (args: any) => void) => {
        ws.onclose = e;
      },
      error: (e: (args: any) => void) => {
        ws.onerror = e;
      },
      open: (e: () => void) => {
        ws.onopen = e;
      },
    };
  } catch {
    throw new Error('No websockets implemented');
  }
};
const handleFetchResponse = (response: Response): Promise<GraphQLResponse> => {
  if (!response.ok) {
    return new Promise((_, reject) => {
      response
        .text()
        .then((text) => {
          try {
            reject(JSON.parse(text));
          } catch (err) {
            reject(text);
          }
        })
        .catch(reject);
    });
  }
  return response.json() as Promise<GraphQLResponse>;
};

export const apiFetch =
  (options: fetchOptions) =>
  (query: string, variables: Record<string, unknown> = {}) => {
    const fetchOptions = options[1] || {};
    if (fetchOptions.method && fetchOptions.method === 'GET') {
      return fetch(`${options[0]}?query=${encodeURIComponent(query)}`, fetchOptions)
        .then(handleFetchResponse)
        .then((response: GraphQLResponse) => {
          if (response.errors) {
            throw new GraphQLError(response);
          }
          return response.data;
        });
    }
    return fetch(`${options[0]}`, {
      body: JSON.stringify({ query, variables }),
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      ...fetchOptions,
    })
      .then(handleFetchResponse)
      .then((response: GraphQLResponse) => {
        if (response.errors) {
          throw new GraphQLError(response);
        }
        return response.data;
      });
  };

export const InternalsBuildQuery = ({
  ops,
  props,
  returns,
  options,
  scalars,
}: {
  props: AllTypesPropsType;
  returns: ReturnTypesType;
  ops: Operations;
  options?: OperationOptions;
  scalars?: ScalarDefinition;
}) => {
  const ibb = (
    k: string,
    o: InputValueType | VType,
    p = '',
    root = true,
    vars: Array<{ name: string; graphQLType: string }> = [],
  ): string => {
    const keyForPath = purifyGraphQLKey(k);
    const newPath = [p, keyForPath].join(SEPARATOR);
    if (!o) {
      return '';
    }
    if (typeof o === 'boolean' || typeof o === 'number') {
      return k;
    }
    if (typeof o === 'string') {
      return `${k} ${o}`;
    }
    if (Array.isArray(o)) {
      const args = InternalArgsBuilt({
        props,
        returns,
        ops,
        scalars,
        vars,
      })(o[0], newPath);
      return `${ibb(args ? `${k}(${args})` : k, o[1], p, false, vars)}`;
    }
    if (k === '__alias') {
      return Object.entries(o)
        .map(([alias, objectUnderAlias]) => {
          if (typeof objectUnderAlias !== 'object' || Array.isArray(objectUnderAlias)) {
            throw new Error(
              'Invalid alias it should be __alias:{ YOUR_ALIAS_NAME: { OPERATION_NAME: { ...selectors }}}',
            );
          }
          const operationName = Object.keys(objectUnderAlias)[0];
          const operation = objectUnderAlias[operationName];
          return ibb(`${alias}:${operationName}`, operation, p, false, vars);
        })
        .join('\n');
    }
    const hasOperationName = root && options?.operationName ? ' ' + options.operationName : '';
    const keyForDirectives = o.__directives ?? '';
    const query = `{${Object.entries(o)
      .filter(([k]) => k !== '__directives')
      .map((e) => ibb(...e, [p, `field<>${keyForPath}`].join(SEPARATOR), false, vars))
      .join('\n')}}`;
    if (!root) {
      return `${k} ${keyForDirectives}${hasOperationName} ${query}`;
    }
    const varsString = vars.map((v) => `${v.name}: ${v.graphQLType}`).join(', ');
    return `${k} ${keyForDirectives}${hasOperationName}${varsString ? `(${varsString})` : ''} ${query}`;
  };
  return ibb;
};

type UnionOverrideKeys<T, U> = Omit<T, keyof U> & U;

export const Thunder =
  <SCLR extends ScalarDefinition>(fn: FetchFunction, thunderGraphQLOptions?: ThunderGraphQLOptions<SCLR>) =>
  <O extends keyof typeof Ops, OVERRIDESCLR extends SCLR, R extends keyof ValueTypes = GenericOperation<O>>(
    operation: O,
    graphqlOptions?: ThunderGraphQLOptions<OVERRIDESCLR>,
  ) =>
  <Z extends ValueTypes[R]>(
    o: Z & {
      [P in keyof Z]: P extends keyof ValueTypes[R] ? Z[P] : never;
    },
    ops?: OperationOptions & { variables?: Record<string, unknown> },
  ) => {
    const options = {
      ...thunderGraphQLOptions,
      ...graphqlOptions,
    };
    return fn(
      Zeus(operation, o, {
        operationOptions: ops,
        scalars: options?.scalars,
      }),
      ops?.variables,
    ).then((data) => {
      if (options?.scalars) {
        return decodeScalarsInResponse({
          response: data,
          initialOp: operation,
          initialZeusQuery: o as VType,
          returns: ReturnTypes,
          scalars: options.scalars,
          ops: Ops,
        });
      }
      return data;
    }) as Promise<InputType<GraphQLTypes[R], Z, UnionOverrideKeys<SCLR, OVERRIDESCLR>>>;
  };

export const Chain = (...options: chainOptions) => Thunder(apiFetch(options));

export const SubscriptionThunder =
  <SCLR extends ScalarDefinition>(fn: SubscriptionFunction, thunderGraphQLOptions?: ThunderGraphQLOptions<SCLR>) =>
  <O extends keyof typeof Ops, OVERRIDESCLR extends SCLR, R extends keyof ValueTypes = GenericOperation<O>>(
    operation: O,
    graphqlOptions?: ThunderGraphQLOptions<OVERRIDESCLR>,
  ) =>
  <Z extends ValueTypes[R]>(
    o: Z & {
      [P in keyof Z]: P extends keyof ValueTypes[R] ? Z[P] : never;
    },
    ops?: OperationOptions & { variables?: ExtractVariables<Z> },
  ) => {
    const options = {
      ...thunderGraphQLOptions,
      ...graphqlOptions,
    };
    type CombinedSCLR = UnionOverrideKeys<SCLR, OVERRIDESCLR>;
    const returnedFunction = fn(
      Zeus(operation, o, {
        operationOptions: ops,
        scalars: options?.scalars,
      }),
    ) as SubscriptionToGraphQL<Z, GraphQLTypes[R], CombinedSCLR>;
    if (returnedFunction?.on && options?.scalars) {
      const wrapped = returnedFunction.on;
      returnedFunction.on = (fnToCall: (args: InputType<GraphQLTypes[R], Z, CombinedSCLR>) => void) =>
        wrapped((data: InputType<GraphQLTypes[R], Z, CombinedSCLR>) => {
          if (options?.scalars) {
            return fnToCall(
              decodeScalarsInResponse({
                response: data,
                initialOp: operation,
                initialZeusQuery: o as VType,
                returns: ReturnTypes,
                scalars: options.scalars,
                ops: Ops,
              }),
            );
          }
          return fnToCall(data);
        });
    }
    return returnedFunction;
  };

export const Subscription = (...options: chainOptions) => SubscriptionThunder(apiSubscription(options));
export const Zeus = <
  Z extends ValueTypes[R],
  O extends keyof typeof Ops,
  R extends keyof ValueTypes = GenericOperation<O>,
>(
  operation: O,
  o: Z,
  ops?: {
    operationOptions?: OperationOptions;
    scalars?: ScalarDefinition;
  },
) =>
  InternalsBuildQuery({
    props: AllTypesProps,
    returns: ReturnTypes,
    ops: Ops,
    options: ops?.operationOptions,
    scalars: ops?.scalars,
  })(operation, o as VType);

export const ZeusSelect = <T>() => ((t: unknown) => t) as SelectionFunction<T>;

export const Selector = <T extends keyof ValueTypes>(key: T) => key && ZeusSelect<ValueTypes[T]>();

export const TypeFromSelector = <T extends keyof ValueTypes>(key: T) => key && ZeusSelect<ValueTypes[T]>();
export const Gql = Chain(HOST, {
  headers: {
    'Content-Type': 'application/json',
    ...HEADERS,
  },
});

export const ZeusScalars = ZeusSelect<ScalarCoders>();

type BaseSymbol = number | string | undefined | boolean | null;

type ScalarsSelector<T, V> = {
  [X in Required<{
    [P in keyof T]: P extends keyof V
      ? V[P] extends Array<any> | undefined
        ? never
        : T[P] extends BaseSymbol | Array<BaseSymbol>
        ? P
        : never
      : never;
  }>[keyof T]]: true;
};

export const fields = <T extends keyof ModelTypes>(k: T) => {
  const t = ReturnTypes[k];
  const fnType = k in AllTypesProps ? AllTypesProps[k as keyof typeof AllTypesProps] : undefined;
  const hasFnTypes = typeof fnType === 'object' ? fnType : undefined;
  const o = Object.fromEntries(
    Object.entries(t)
      .filter(([k, value]) => {
        const isFunctionType = hasFnTypes && k in hasFnTypes && !!hasFnTypes[k as keyof typeof hasFnTypes];
        if (isFunctionType) return false;
        const isReturnType = ReturnTypes[value as string];
        if (!isReturnType) return true;
        if (typeof isReturnType !== 'string') return false;
        if (isReturnType.startsWith('scalar.')) {
          return true;
        }
        return false;
      })
      .map(([key]) => [key, true as const]),
  );
  return o as ScalarsSelector<ModelTypes[T], T extends keyof ValueTypes ? ValueTypes[T] : never>;
};

export const decodeScalarsInResponse = <O extends Operations>({
  response,
  scalars,
  returns,
  ops,
  initialZeusQuery,
  initialOp,
}: {
  ops: O;
  response: any;
  returns: ReturnTypesType;
  scalars?: Record<string, ScalarResolver | undefined>;
  initialOp: keyof O;
  initialZeusQuery: InputValueType | VType;
}) => {
  if (!scalars) {
    return response;
  }
  const builder = PrepareScalarPaths({
    ops,
    returns,
  });

  const scalarPaths = builder(initialOp as string, ops[initialOp], initialZeusQuery);
  if (scalarPaths) {
    const r = traverseResponse({ scalarPaths, resolvers: scalars })(initialOp as string, response, [ops[initialOp]]);
    return r;
  }
  return response;
};

export const traverseResponse = ({
  resolvers,
  scalarPaths,
}: {
  scalarPaths: { [x: string]: `scalar.${string}` };
  resolvers: {
    [x: string]: ScalarResolver | undefined;
  };
}) => {
  const ibb = (k: string, o: InputValueType | VType, p: string[] = []): unknown => {
    if (Array.isArray(o)) {
      return o.map((eachO) => ibb(k, eachO, p));
    }
    if (o == null) {
      return o;
    }
    const scalarPathString = p.join(SEPARATOR);
    const currentScalarString = scalarPaths[scalarPathString];
    if (currentScalarString) {
      const currentDecoder = resolvers[currentScalarString.split('.')[1]]?.decode;
      if (currentDecoder) {
        return currentDecoder(o);
      }
    }
    if (typeof o === 'boolean' || typeof o === 'number' || typeof o === 'string' || !o) {
      return o;
    }
    const entries = Object.entries(o).map(([k, v]) => [k, ibb(k, v, [...p, purifyGraphQLKey(k)])] as const);
    const objectFromEntries = entries.reduce<Record<string, unknown>>((a, [k, v]) => {
      a[k] = v;
      return a;
    }, {});
    return objectFromEntries;
  };
  return ibb;
};

export type AllTypesPropsType = {
  [x: string]:
    | undefined
    | `scalar.${string}`
    | 'enum'
    | {
        [x: string]:
          | undefined
          | string
          | {
              [x: string]: string | undefined;
            };
      };
};

export type ReturnTypesType = {
  [x: string]:
    | {
        [x: string]: string | undefined;
      }
    | `scalar.${string}`
    | undefined;
};
export type InputValueType = {
  [x: string]: undefined | boolean | string | number | [any, undefined | boolean | InputValueType] | InputValueType;
};
export type VType =
  | undefined
  | boolean
  | string
  | number
  | [any, undefined | boolean | InputValueType]
  | InputValueType;

export type PlainType = boolean | number | string | null | undefined;
export type ZeusArgsType =
  | PlainType
  | {
      [x: string]: ZeusArgsType;
    }
  | Array<ZeusArgsType>;

export type Operations = Record<string, string>;

export type VariableDefinition = {
  [x: string]: unknown;
};

export const SEPARATOR = '|';

export type fetchOptions = Parameters<typeof fetch>;
type websocketOptions = typeof WebSocket extends new (...args: infer R) => WebSocket ? R : never;
export type chainOptions = [fetchOptions[0], fetchOptions[1] & { websocket?: websocketOptions }] | [fetchOptions[0]];
export type FetchFunction = (query: string, variables?: Record<string, unknown>) => Promise<any>;
export type SubscriptionFunction = (query: string) => any;
type NotUndefined<T> = T extends undefined ? never : T;
export type ResolverType<F> = NotUndefined<F extends [infer ARGS, any] ? ARGS : undefined>;

export type OperationOptions = {
  operationName?: string;
};

export type ScalarCoder = Record<string, (s: unknown) => string>;

export interface GraphQLResponse {
  data?: Record<string, any>;
  errors?: Array<{
    message: string;
  }>;
}
export class GraphQLError extends Error {
  constructor(public response: GraphQLResponse) {
    super('');
    console.error(response);
  }
  toString() {
    return 'GraphQL Response Error';
  }
}
export type GenericOperation<O> = O extends keyof typeof Ops ? typeof Ops[O] : never;
export type ThunderGraphQLOptions<SCLR extends ScalarDefinition> = {
  scalars?: SCLR | ScalarCoders;
};

const ExtractScalar = (mappedParts: string[], returns: ReturnTypesType): `scalar.${string}` | undefined => {
  if (mappedParts.length === 0) {
    return;
  }
  const oKey = mappedParts[0];
  const returnP1 = returns[oKey];
  if (typeof returnP1 === 'object') {
    const returnP2 = returnP1[mappedParts[1]];
    if (returnP2) {
      return ExtractScalar([returnP2, ...mappedParts.slice(2)], returns);
    }
    return undefined;
  }
  return returnP1 as `scalar.${string}` | undefined;
};

export const PrepareScalarPaths = ({ ops, returns }: { returns: ReturnTypesType; ops: Operations }) => {
  const ibb = (
    k: string,
    originalKey: string,
    o: InputValueType | VType,
    p: string[] = [],
    pOriginals: string[] = [],
    root = true,
  ): { [x: string]: `scalar.${string}` } | undefined => {
    if (!o) {
      return;
    }
    if (typeof o === 'boolean' || typeof o === 'number' || typeof o === 'string') {
      const extractionArray = [...pOriginals, originalKey];
      const isScalar = ExtractScalar(extractionArray, returns);
      if (isScalar?.startsWith('scalar')) {
        const partOfTree = {
          [[...p, k].join(SEPARATOR)]: isScalar,
        };
        return partOfTree;
      }
      return {};
    }
    if (Array.isArray(o)) {
      return ibb(k, k, o[1], p, pOriginals, false);
    }
    if (k === '__alias') {
      return Object.entries(o)
        .map(([alias, objectUnderAlias]) => {
          if (typeof objectUnderAlias !== 'object' || Array.isArray(objectUnderAlias)) {
            throw new Error(
              'Invalid alias it should be __alias:{ YOUR_ALIAS_NAME: { OPERATION_NAME: { ...selectors }}}',
            );
          }
          const operationName = Object.keys(objectUnderAlias)[0];
          const operation = objectUnderAlias[operationName];
          return ibb(alias, operationName, operation, p, pOriginals, false);
        })
        .reduce((a, b) => ({
          ...a,
          ...b,
        }));
    }
    const keyName = root ? ops[k] : k;
    return Object.entries(o)
      .filter(([k]) => k !== '__directives')
      .map(([k, v]) => {
        // Inline fragments shouldn't be added to the path as they aren't a field
        const isInlineFragment = originalKey.match(/^...\s*on/) != null;
        return ibb(
          k,
          k,
          v,
          isInlineFragment ? p : [...p, purifyGraphQLKey(keyName || k)],
          isInlineFragment ? pOriginals : [...pOriginals, purifyGraphQLKey(originalKey)],
          false,
        );
      })
      .reduce((a, b) => ({
        ...a,
        ...b,
      }));
  };
  return ibb;
};

export const purifyGraphQLKey = (k: string) => k.replace(/\([^)]*\)/g, '').replace(/^[^:]*\:/g, '');

const mapPart = (p: string) => {
  const [isArg, isField] = p.split('<>');
  if (isField) {
    return {
      v: isField,
      __type: 'field',
    } as const;
  }
  return {
    v: isArg,
    __type: 'arg',
  } as const;
};

type Part = ReturnType<typeof mapPart>;

export const ResolveFromPath = (props: AllTypesPropsType, returns: ReturnTypesType, ops: Operations) => {
  const ResolvePropsType = (mappedParts: Part[]) => {
    const oKey = ops[mappedParts[0].v];
    const propsP1 = oKey ? props[oKey] : props[mappedParts[0].v];
    if (propsP1 === 'enum' && mappedParts.length === 1) {
      return 'enum';
    }
    if (typeof propsP1 === 'string' && propsP1.startsWith('scalar.') && mappedParts.length === 1) {
      return propsP1;
    }
    if (typeof propsP1 === 'object') {
      if (mappedParts.length < 2) {
        return 'not';
      }
      const propsP2 = propsP1[mappedParts[1].v];
      if (typeof propsP2 === 'string') {
        return rpp(
          `${propsP2}${SEPARATOR}${mappedParts
            .slice(2)
            .map((mp) => mp.v)
            .join(SEPARATOR)}`,
        );
      }
      if (typeof propsP2 === 'object') {
        if (mappedParts.length < 3) {
          return 'not';
        }
        const propsP3 = propsP2[mappedParts[2].v];
        if (propsP3 && mappedParts[2].__type === 'arg') {
          return rpp(
            `${propsP3}${SEPARATOR}${mappedParts
              .slice(3)
              .map((mp) => mp.v)
              .join(SEPARATOR)}`,
          );
        }
      }
    }
  };
  const ResolveReturnType = (mappedParts: Part[]) => {
    if (mappedParts.length === 0) {
      return 'not';
    }
    const oKey = ops[mappedParts[0].v];
    const returnP1 = oKey ? returns[oKey] : returns[mappedParts[0].v];
    if (typeof returnP1 === 'object') {
      if (mappedParts.length < 2) return 'not';
      const returnP2 = returnP1[mappedParts[1].v];
      if (returnP2) {
        return rpp(
          `${returnP2}${SEPARATOR}${mappedParts
            .slice(2)
            .map((mp) => mp.v)
            .join(SEPARATOR)}`,
        );
      }
    }
  };
  const rpp = (path: string): 'enum' | 'not' | `scalar.${string}` => {
    const parts = path.split(SEPARATOR).filter((l) => l.length > 0);
    const mappedParts = parts.map(mapPart);
    const propsP1 = ResolvePropsType(mappedParts);
    if (propsP1) {
      return propsP1;
    }
    const returnP1 = ResolveReturnType(mappedParts);
    if (returnP1) {
      return returnP1;
    }
    return 'not';
  };
  return rpp;
};

export const InternalArgsBuilt = ({
  props,
  ops,
  returns,
  scalars,
  vars,
}: {
  props: AllTypesPropsType;
  returns: ReturnTypesType;
  ops: Operations;
  scalars?: ScalarDefinition;
  vars: Array<{ name: string; graphQLType: string }>;
}) => {
  const arb = (a: ZeusArgsType, p = '', root = true): string => {
    if (typeof a === 'string') {
      if (a.startsWith(START_VAR_NAME)) {
        const [varName, graphQLType] = a.replace(START_VAR_NAME, '$').split(GRAPHQL_TYPE_SEPARATOR);
        const v = vars.find((v) => v.name === varName);
        if (!v) {
          vars.push({
            name: varName,
            graphQLType,
          });
        } else {
          if (v.graphQLType !== graphQLType) {
            throw new Error(
              `Invalid variable exists with two different GraphQL Types, "${v.graphQLType}" and ${graphQLType}`,
            );
          }
        }
        return varName;
      }
    }
    const checkType = ResolveFromPath(props, returns, ops)(p);
    if (checkType.startsWith('scalar.')) {
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      const [_, ...splittedScalar] = checkType.split('.');
      const scalarKey = splittedScalar.join('.');
      return (scalars?.[scalarKey]?.encode?.(a) as string) || JSON.stringify(a);
    }
    if (Array.isArray(a)) {
      return `[${a.map((arr) => arb(arr, p, false)).join(', ')}]`;
    }
    if (typeof a === 'string') {
      if (checkType === 'enum') {
        return a;
      }
      return `${JSON.stringify(a)}`;
    }
    if (typeof a === 'object') {
      if (a === null) {
        return `null`;
      }
      const returnedObjectString = Object.entries(a)
        .filter(([, v]) => typeof v !== 'undefined')
        .map(([k, v]) => `${k}: ${arb(v, [p, k].join(SEPARATOR), false)}`)
        .join(',\n');
      if (!root) {
        return `{${returnedObjectString}}`;
      }
      return returnedObjectString;
    }
    return `${a}`;
  };
  return arb;
};

export const resolverFor = <X, T extends keyof ResolverInputTypes, Z extends keyof ResolverInputTypes[T]>(
  type: T,
  field: Z,
  fn: (
    args: Required<ResolverInputTypes[T]>[Z] extends [infer Input, any] ? Input : any,
    source: any,
  ) => Z extends keyof ModelTypes[T] ? ModelTypes[T][Z] | Promise<ModelTypes[T][Z]> | X : never,
) => fn as (args?: any, source?: any) => ReturnType<typeof fn>;

export type UnwrapPromise<T> = T extends Promise<infer R> ? R : T;
export type ZeusState<T extends (...args: any[]) => Promise<any>> = NonNullable<UnwrapPromise<ReturnType<T>>>;
export type ZeusHook<
  T extends (...args: any[]) => Record<string, (...args: any[]) => Promise<any>>,
  N extends keyof ReturnType<T>,
> = ZeusState<ReturnType<T>[N]>;

export type WithTypeNameValue<T> = T & {
  __typename?: boolean;
  __directives?: string;
};
export type AliasType<T> = WithTypeNameValue<T> & {
  __alias?: Record<string, WithTypeNameValue<T>>;
};
type DeepAnify<T> = {
  [P in keyof T]?: any;
};
type IsPayLoad<T> = T extends [any, infer PayLoad] ? PayLoad : T;
export type ScalarDefinition = Record<string, ScalarResolver>;

type IsScalar<S, SCLR extends ScalarDefinition> = S extends 'scalar' & { name: infer T }
  ? T extends keyof SCLR
    ? SCLR[T]['decode'] extends (s: unknown) => unknown
      ? ReturnType<SCLR[T]['decode']>
      : unknown
    : unknown
  : S;
type IsArray<T, U, SCLR extends ScalarDefinition> = T extends Array<infer R>
  ? InputType<R, U, SCLR>[]
  : InputType<T, U, SCLR>;
type FlattenArray<T> = T extends Array<infer R> ? R : T;
type BaseZeusResolver = boolean | 1 | string | Variable<any, string>;

type IsInterfaced<SRC extends DeepAnify<DST>, DST, SCLR extends ScalarDefinition> = FlattenArray<SRC> extends
  | ZEUS_INTERFACES
  | ZEUS_UNIONS
  ? {
      [P in keyof SRC]: SRC[P] extends '__union' & infer R
        ? P extends keyof DST
          ? IsArray<R, '__typename' extends keyof DST ? DST[P] & { __typename: true } : DST[P], SCLR>
          : IsArray<R, '__typename' extends keyof DST ? { __typename: true } : Record<string, never>, SCLR>
        : never;
    }[keyof SRC] & {
      [P in keyof Omit<
        Pick<
          SRC,
          {
            [P in keyof DST]: SRC[P] extends '__union' & infer R ? never : P;
          }[keyof DST]
        >,
        '__typename'
      >]: IsPayLoad<DST[P]> extends BaseZeusResolver ? IsScalar<SRC[P], SCLR> : IsArray<SRC[P], DST[P], SCLR>;
    }
  : {
      [P in keyof Pick<SRC, keyof DST>]: IsPayLoad<DST[P]> extends BaseZeusResolver
        ? IsScalar<SRC[P], SCLR>
        : IsArray<SRC[P], DST[P], SCLR>;
    };

export type MapType<SRC, DST, SCLR extends ScalarDefinition> = SRC extends DeepAnify<DST>
  ? IsInterfaced<SRC, DST, SCLR>
  : never;
// eslint-disable-next-line @typescript-eslint/ban-types
export type InputType<SRC, DST, SCLR extends ScalarDefinition = {}> = IsPayLoad<DST> extends { __alias: infer R }
  ? {
      [P in keyof R]: MapType<SRC, R[P], SCLR>[keyof MapType<SRC, R[P], SCLR>];
    } & MapType<SRC, Omit<IsPayLoad<DST>, '__alias'>, SCLR>
  : MapType<SRC, IsPayLoad<DST>, SCLR>;
export type SubscriptionToGraphQL<Z, T, SCLR extends ScalarDefinition> = {
  ws: WebSocket;
  on: (fn: (args: InputType<T, Z, SCLR>) => void) => void;
  off: (fn: (e: { data?: InputType<T, Z, SCLR>; code?: number; reason?: string; message?: string }) => void) => void;
  error: (fn: (e: { data?: InputType<T, Z, SCLR>; errors?: string[] }) => void) => void;
  open: () => void;
};

// eslint-disable-next-line @typescript-eslint/ban-types
export type FromSelector<SELECTOR, NAME extends keyof GraphQLTypes, SCLR extends ScalarDefinition = {}> = InputType<
  GraphQLTypes[NAME],
  SELECTOR,
  SCLR
>;

export type ScalarResolver = {
  encode?: (s: unknown) => string;
  decode?: (s: unknown) => unknown;
};

export type SelectionFunction<V> = <Z extends V>(
  t: Z & {
    [P in keyof Z]: P extends keyof V ? Z[P] : never;
  },
) => Z;

type BuiltInVariableTypes = {
  ['String']: string;
  ['Int']: number;
  ['Float']: number;
  ['Boolean']: boolean;
};
type AllVariableTypes = keyof BuiltInVariableTypes | keyof ZEUS_VARIABLES;
type VariableRequired<T extends string> = `${T}!` | T | `[${T}]` | `[${T}]!` | `[${T}!]` | `[${T}!]!`;
type VR<T extends string> = VariableRequired<VariableRequired<T>>;

export type GraphQLVariableType = VR<AllVariableTypes>;

type ExtractVariableTypeString<T extends string> = T extends VR<infer R1>
  ? R1 extends VR<infer R2>
    ? R2 extends VR<infer R3>
      ? R3 extends VR<infer R4>
        ? R4 extends VR<infer R5>
          ? R5
          : R4
        : R3
      : R2
    : R1
  : T;

type DecomposeType<T, Type> = T extends `[${infer R}]`
  ? Array<DecomposeType<R, Type>> | undefined
  : T extends `${infer R}!`
  ? NonNullable<DecomposeType<R, Type>>
  : Type | undefined;

type ExtractTypeFromGraphQLType<T extends string> = T extends keyof ZEUS_VARIABLES
  ? ZEUS_VARIABLES[T]
  : T extends keyof BuiltInVariableTypes
  ? BuiltInVariableTypes[T]
  : any;

export type GetVariableType<T extends string> = DecomposeType<
  T,
  ExtractTypeFromGraphQLType<ExtractVariableTypeString<T>>
>;

type UndefinedKeys<T> = {
  [K in keyof T]-?: T[K] extends NonNullable<T[K]> ? never : K;
}[keyof T];

type WithNullableKeys<T> = Pick<T, UndefinedKeys<T>>;
type WithNonNullableKeys<T> = Omit<T, UndefinedKeys<T>>;

type OptionalKeys<T> = {
  [P in keyof T]?: T[P];
};

export type WithOptionalNullables<T> = OptionalKeys<WithNullableKeys<T>> & WithNonNullableKeys<T>;

export type Variable<T extends GraphQLVariableType, Name extends string> = {
  ' __zeus_name': Name;
  ' __zeus_type': T;
};

export type ExtractVariablesDeep<Query> = Query extends Variable<infer VType, infer VName>
  ? { [key in VName]: GetVariableType<VType> }
  : Query extends string | number | boolean | Array<string | number | boolean>
  ? // eslint-disable-next-line @typescript-eslint/ban-types
    {}
  : UnionToIntersection<{ [K in keyof Query]: WithOptionalNullables<ExtractVariablesDeep<Query[K]>> }[keyof Query]>;

export type ExtractVariables<Query> = Query extends Variable<infer VType, infer VName>
  ? { [key in VName]: GetVariableType<VType> }
  : Query extends [infer Inputs, infer Outputs]
  ? ExtractVariablesDeep<Inputs> & ExtractVariables<Outputs>
  : Query extends string | number | boolean | Array<string | number | boolean>
  ? // eslint-disable-next-line @typescript-eslint/ban-types
    {}
  : UnionToIntersection<{ [K in keyof Query]: WithOptionalNullables<ExtractVariables<Query[K]>> }[keyof Query]>;

type UnionToIntersection<U> = (U extends any ? (k: U) => void : never) extends (k: infer I) => void ? I : never;

export const START_VAR_NAME = `$ZEUS_VAR`;
export const GRAPHQL_TYPE_SEPARATOR = `__$GRAPHQL__`;

export const $ = <Type extends GraphQLVariableType, Name extends string>(name: Name, graphqlType: Type) => {
  return (START_VAR_NAME + name + GRAPHQL_TYPE_SEPARATOR + graphqlType) as unknown as Variable<Type, Name>;
};
type ZEUS_INTERFACES = never
export type ScalarCoders = {
	AWSJSON?: ScalarResolver;
	ID?: ScalarResolver;
}
type ZEUS_UNIONS = never

export type ValueTypes = {
    ["Query"]: AliasType<{
getLastCompletedStep?: [{	input: ValueTypes["GetLastCompletedStepInput"] | Variable<any, string>},ValueTypes["GetLastCompletedStepOutput"]],
getPronunciationGraderParameters?: [{	input: ValueTypes["GetPronunciationGraderParametersInput"] | Variable<any, string>},ValueTypes["GetPronunciationGraderParametersOutput"]],
	me?:ValueTypes["MeOutput"],
	listChildProfiles?:ValueTypes["ListChildProfilesOutput"],
		__typename?: boolean | `@${string}`
}>;
	["GetLastCompletedStepOutput"]: AliasType<{
	lesson?:boolean | `@${string}`,
	task?:boolean | `@${string}`,
	step?:boolean | `@${string}`,
	completedAt?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["GetLastCompletedStepInput"]: {
	profileId: ValueTypes["ID"] | Variable<any, string>
};
	["GetPronunciationGraderParametersOutput"]: AliasType<{
	graderType?:boolean | `@${string}`,
	parameters?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["GraderType"]:GraderType;
	/** The `AWSJSON` scalar type provided by AWS AppSync, represents a JSON string that complies with [RFC 8259](https://tools.ietf.org/html/rfc8259).  Maps like "**{\\"upvotes\\": 10}**", lists like "**[1,2,3]**", and scalar values like "**\\"AWSJSON example string\\"**", "**1**", and "**true**" are accepted as valid JSON and will automatically be parsed and loaded in the resolver mapping templates as Maps, Lists, or Scalar values rather than as the literal input strings.  Invalid JSON strings like "**{a: 1}**", "**{'a': 1}**" and "**Unquoted string**" will throw GraphQL validation errors. */
["AWSJSON"]:unknown;
	["GetPronunciationGraderParametersInput"]: {
	graderType: ValueTypes["GraderType"] | Variable<any, string>,
	refText: string | Variable<any, string>
};
	["MeOutput"]: AliasType<{
	parent?:ValueTypes["Parent"],
		__typename?: boolean | `@${string}`
}>;
	["Parent"]: AliasType<{
	id?:boolean | `@${string}`,
	preferredName?:boolean | `@${string}`,
	email?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["ListChildProfilesOutput"]: AliasType<{
	childProfiles?:ValueTypes["ChildProfile"],
		__typename?: boolean | `@${string}`
}>;
	["ChildProfile"]: AliasType<{
	id?:boolean | `@${string}`,
	name?:boolean | `@${string}`,
	age?:boolean | `@${string}`,
	incorrectHelpThreshold?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["Mutation"]: AliasType<{
completeStep?: [{	input: ValueTypes["CompleteStepInput"] | Variable<any, string>},ValueTypes["CompleteStepOutput"]],
checkAnswer?: [{	input: ValueTypes["CheckAnswerInput"] | Variable<any, string>},ValueTypes["CheckAnswerOutput"]],
checkPronunciation?: [{	input: ValueTypes["CheckPronunciationInput"] | Variable<any, string>},ValueTypes["CheckPronunciationOutput"]],
checkWriting?: [{	input: ValueTypes["CheckWritingInput"] | Variable<any, string>},ValueTypes["CheckWritingOutput"]],
initializePronunciationGrader?: [{	input: ValueTypes["InitializePronunciationGraderInput"] | Variable<any, string>},ValueTypes["InitializePronunciationGraderOutput"]],
textToSpeech?: [{	input: ValueTypes["TextToSpeechInput"] | Variable<any, string>},ValueTypes["TextToSpeechOutput"]],
generateSpeech?: [{	input: ValueTypes["GenerateSpeechInput"] | Variable<any, string>},ValueTypes["GenerateSpeechOutput"]],
textToCharacterSpeech?: [{	input: ValueTypes["TextToCharacterSpeechInput"] | Variable<any, string>},ValueTypes["SpeechOutput"]],
generateCharacterSpeech?: [{	input: ValueTypes["GenerateCharacterSpeechInput"] | Variable<any, string>},ValueTypes["SpeechOutput"]],
notifyTextToSpeechChunkReceived?: [{	input: ValueTypes["TextToSpeechChunkInput"] | Variable<any, string>},ValueTypes["TextToSpeechChunk"]],
createParentAccount?: [{	input: ValueTypes["CreateParentAccountInput"] | Variable<any, string>},ValueTypes["CreateParentAccountOutput"]],
updateParentAccount?: [{	input: ValueTypes["UpdateParentAccountInput"] | Variable<any, string>},ValueTypes["UpdateParentAccountOutput"]],
createChildProfile?: [{	input: ValueTypes["CreateChildProfileInput"] | Variable<any, string>},ValueTypes["CreateChildProfileOutput"]],
updateChildProfile?: [{	input: ValueTypes["UpdateChildProfileInput"] | Variable<any, string>},ValueTypes["UpdateChildProfileOutput"]],
registerDevice?: [{	input: ValueTypes["RegisterDeviceInput"] | Variable<any, string>},ValueTypes["RegisterDeviceOutput"]],
unregisterDevice?: [{	input: ValueTypes["UnregisterDeviceInput"] | Variable<any, string>},ValueTypes["UnregisterDeviceOutput"]],
startSession?: [{	input: ValueTypes["StartSessionInput"] | Variable<any, string>},ValueTypes["StartSessionOutput"]],
	deleteParentAccount?:ValueTypes["DeleteParentAccountOutput"],
generateUploadUrl?: [{	input: ValueTypes["GenerateUploadUrlInput"] | Variable<any, string>},ValueTypes["GenerateUploadUrlOutput"]],
		__typename?: boolean | `@${string}`
}>;
	["CompleteStepOutput"]: AliasType<{
	completedAt?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["CompleteStepInput"]: {
	profileId: ValueTypes["ID"] | Variable<any, string>,
	lesson: number | Variable<any, string>,
	task: number | Variable<any, string>,
	step: number | Variable<any, string>
};
	["CheckAnswerOutput"]: AliasType<{
	isCorrect?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["CheckAnswerInput"]: {
	story: string | Variable<any, string>,
	question: string | Variable<any, string>,
	receivedAnswer: string | Variable<any, string>,
	prototypeAnswer: string | Variable<any, string>
};
	["CheckPronunciationOutput"]: AliasType<{
	overall?:boolean | `@${string}`,
	pronunciation?:boolean | `@${string}`,
	fluency?:boolean | `@${string}`,
	integrity?:boolean | `@${string}`,
	words?:ValueTypes["Word"],
	isCorrect?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["Word"]: AliasType<{
	word?:boolean | `@${string}`,
	score?:boolean | `@${string}`,
	phoneScore?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["CheckPronunciationInput"]: {
	audioBase64: string | Variable<any, string>,
	refText: string | Variable<any, string>,
	ageGroup: number | Variable<any, string>
};
	["CheckWritingOutput"]: AliasType<{
	evaluation?:boolean | `@${string}`,
	storageKey?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["CheckWritingEvaluation"]:CheckWritingEvaluation;
	["CheckWritingInput"]: {
	referencePath: string | Variable<any, string>,
	userPath: string | Variable<any, string>,
	reference: string | Variable<any, string>,
	type: ValueTypes["CheckWritingType"] | Variable<any, string>
};
	["CheckWritingType"]:CheckWritingType;
	["InitializePronunciationGraderOutput"]: AliasType<{
	provider?:boolean | `@${string}`,
	metadata?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["GraderProvider"]:GraderProvider;
	["InitializePronunciationGraderInput"]: {
	provider: ValueTypes["GraderProvider"] | Variable<any, string>,
	metadata: ValueTypes["AWSJSON"] | Variable<any, string>
};
	["TextToSpeechOutput"]: AliasType<{
	id?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["TextToSpeechInput"]: {
	id: ValueTypes["ID"] | Variable<any, string>,
	text: string | Variable<any, string>,
	voiceId: string | Variable<any, string>,
	stability?: number | undefined | null | Variable<any, string>,
	similarityBoost?: number | undefined | null | Variable<any, string>,
	style?: number | undefined | null | Variable<any, string>,
	useSpeakerBoost?: boolean | undefined | null | Variable<any, string>,
	model?: string | undefined | null | Variable<any, string>
};
	["GenerateSpeechOutput"]: AliasType<{
	id?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["GenerateSpeechInput"]: {
	id: ValueTypes["ID"] | Variable<any, string>,
	prompt: string | Variable<any, string>,
	errorHandlingMessage?: string | undefined | null | Variable<any, string>,
	options?: ValueTypes["GenerateSpeechOptions"] | undefined | null | Variable<any, string>
};
	["GenerateSpeechOptions"]: {
	voiceId: string | Variable<any, string>,
	model?: string | undefined | null | Variable<any, string>,
	stability?: number | undefined | null | Variable<any, string>,
	similarityBoost?: number | undefined | null | Variable<any, string>,
	style?: number | undefined | null | Variable<any, string>,
	useSpeakerBoost?: boolean | undefined | null | Variable<any, string>
};
	["SpeechOutput"]: AliasType<{
	id?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["TextToCharacterSpeechInput"]: {
	id: ValueTypes["ID"] | Variable<any, string>,
	character: string | Variable<any, string>,
	text: string | Variable<any, string>
};
	["GenerateCharacterSpeechInput"]: {
	id: ValueTypes["ID"] | Variable<any, string>,
	character: string | Variable<any, string>,
	errorHandlingMessage?: string | undefined | null | Variable<any, string>,
	promptOptions: ValueTypes["PromptOptions"] | Variable<any, string>
};
	["PromptOptions"]: {
	promptType: ValueTypes["PromptType"] | Variable<any, string>,
	metadata: ValueTypes["AWSJSON"] | Variable<any, string>
};
	["PromptType"]:PromptType;
	["TextToSpeechChunk"]: AliasType<{
	id?:boolean | `@${string}`,
	chunk?:boolean | `@${string}`,
	order?:boolean | `@${string}`,
	isComplete?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["TextToSpeechChunkInput"]: {
	id: ValueTypes["ID"] | Variable<any, string>,
	chunk: string | Variable<any, string>,
	order: number | Variable<any, string>,
	isComplete: boolean | Variable<any, string>
};
	["CreateParentAccountOutput"]: AliasType<{
	success?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["CreateParentAccountInput"]: {
	email: string | Variable<any, string>,
	password: string | Variable<any, string>,
	preferredName: string | Variable<any, string>
};
	["UpdateParentAccountOutput"]: AliasType<{
	success?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["UpdateParentAccountInput"]: {
	preferredName?: string | undefined | null | Variable<any, string>
};
	["CreateChildProfileOutput"]: AliasType<{
	success?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["CreateChildProfileInput"]: {
	name: string | Variable<any, string>,
	age: number | Variable<any, string>,
	incorrectHelpThreshold: number | Variable<any, string>
};
	["UpdateChildProfileOutput"]: AliasType<{
	success?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["UpdateChildProfileInput"]: {
	id: ValueTypes["ID"] | Variable<any, string>,
	name?: string | undefined | null | Variable<any, string>,
	age?: number | undefined | null | Variable<any, string>,
	incorrectHelpThreshold?: number | undefined | null | Variable<any, string>
};
	["RegisterDeviceOutput"]: AliasType<{
	success?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["RegisterDeviceInput"]: {
	userId: string | Variable<any, string>,
	deviceId: string | Variable<any, string>,
	token: string | Variable<any, string>,
	platform: string | Variable<any, string>
};
	["UnregisterDeviceOutput"]: AliasType<{
	success?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["UnregisterDeviceInput"]: {
	userId: string | Variable<any, string>,
	deviceId: string | Variable<any, string>
};
	["StartSessionOutput"]: AliasType<{
	sessionNumber?:boolean | `@${string}`,
	sessionStartedAt?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["StartSessionInput"]: {
	userId: string | Variable<any, string>
};
	["DeleteParentAccountOutput"]: AliasType<{
	success?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["GenerateUploadUrlOutput"]: AliasType<{
	presignedUrl?:boolean | `@${string}`,
	key?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["GenerateUploadUrlInput"]: {
	uploadType: ValueTypes["UploadType"] | Variable<any, string>,
	contentType: string | Variable<any, string>,
	profileId: string | Variable<any, string>,
	metadata: ValueTypes["AWSJSON"] | Variable<any, string>
};
	["UploadType"]:UploadType;
	["Subscription"]: AliasType<{
onTextToSpeechChunkReceived?: [{	id: ValueTypes["ID"] | Variable<any, string>},ValueTypes["TextToSpeechChunk"]],
		__typename?: boolean | `@${string}`
}>;
	["ID"]:unknown
  }

export type ResolverInputTypes = {
    ["Query"]: AliasType<{
getLastCompletedStep?: [{	input: ResolverInputTypes["GetLastCompletedStepInput"]},ResolverInputTypes["GetLastCompletedStepOutput"]],
getPronunciationGraderParameters?: [{	input: ResolverInputTypes["GetPronunciationGraderParametersInput"]},ResolverInputTypes["GetPronunciationGraderParametersOutput"]],
	me?:ResolverInputTypes["MeOutput"],
	listChildProfiles?:ResolverInputTypes["ListChildProfilesOutput"],
		__typename?: boolean | `@${string}`
}>;
	["GetLastCompletedStepOutput"]: AliasType<{
	lesson?:boolean | `@${string}`,
	task?:boolean | `@${string}`,
	step?:boolean | `@${string}`,
	completedAt?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["GetLastCompletedStepInput"]: {
	profileId: ResolverInputTypes["ID"]
};
	["GetPronunciationGraderParametersOutput"]: AliasType<{
	graderType?:boolean | `@${string}`,
	parameters?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["GraderType"]:GraderType;
	/** The `AWSJSON` scalar type provided by AWS AppSync, represents a JSON string that complies with [RFC 8259](https://tools.ietf.org/html/rfc8259).  Maps like "**{\\"upvotes\\": 10}**", lists like "**[1,2,3]**", and scalar values like "**\\"AWSJSON example string\\"**", "**1**", and "**true**" are accepted as valid JSON and will automatically be parsed and loaded in the resolver mapping templates as Maps, Lists, or Scalar values rather than as the literal input strings.  Invalid JSON strings like "**{a: 1}**", "**{'a': 1}**" and "**Unquoted string**" will throw GraphQL validation errors. */
["AWSJSON"]:unknown;
	["GetPronunciationGraderParametersInput"]: {
	graderType: ResolverInputTypes["GraderType"],
	refText: string
};
	["MeOutput"]: AliasType<{
	parent?:ResolverInputTypes["Parent"],
		__typename?: boolean | `@${string}`
}>;
	["Parent"]: AliasType<{
	id?:boolean | `@${string}`,
	preferredName?:boolean | `@${string}`,
	email?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["ListChildProfilesOutput"]: AliasType<{
	childProfiles?:ResolverInputTypes["ChildProfile"],
		__typename?: boolean | `@${string}`
}>;
	["ChildProfile"]: AliasType<{
	id?:boolean | `@${string}`,
	name?:boolean | `@${string}`,
	age?:boolean | `@${string}`,
	incorrectHelpThreshold?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["Mutation"]: AliasType<{
completeStep?: [{	input: ResolverInputTypes["CompleteStepInput"]},ResolverInputTypes["CompleteStepOutput"]],
checkAnswer?: [{	input: ResolverInputTypes["CheckAnswerInput"]},ResolverInputTypes["CheckAnswerOutput"]],
checkPronunciation?: [{	input: ResolverInputTypes["CheckPronunciationInput"]},ResolverInputTypes["CheckPronunciationOutput"]],
checkWriting?: [{	input: ResolverInputTypes["CheckWritingInput"]},ResolverInputTypes["CheckWritingOutput"]],
initializePronunciationGrader?: [{	input: ResolverInputTypes["InitializePronunciationGraderInput"]},ResolverInputTypes["InitializePronunciationGraderOutput"]],
textToSpeech?: [{	input: ResolverInputTypes["TextToSpeechInput"]},ResolverInputTypes["TextToSpeechOutput"]],
generateSpeech?: [{	input: ResolverInputTypes["GenerateSpeechInput"]},ResolverInputTypes["GenerateSpeechOutput"]],
textToCharacterSpeech?: [{	input: ResolverInputTypes["TextToCharacterSpeechInput"]},ResolverInputTypes["SpeechOutput"]],
generateCharacterSpeech?: [{	input: ResolverInputTypes["GenerateCharacterSpeechInput"]},ResolverInputTypes["SpeechOutput"]],
notifyTextToSpeechChunkReceived?: [{	input: ResolverInputTypes["TextToSpeechChunkInput"]},ResolverInputTypes["TextToSpeechChunk"]],
createParentAccount?: [{	input: ResolverInputTypes["CreateParentAccountInput"]},ResolverInputTypes["CreateParentAccountOutput"]],
updateParentAccount?: [{	input: ResolverInputTypes["UpdateParentAccountInput"]},ResolverInputTypes["UpdateParentAccountOutput"]],
createChildProfile?: [{	input: ResolverInputTypes["CreateChildProfileInput"]},ResolverInputTypes["CreateChildProfileOutput"]],
updateChildProfile?: [{	input: ResolverInputTypes["UpdateChildProfileInput"]},ResolverInputTypes["UpdateChildProfileOutput"]],
registerDevice?: [{	input: ResolverInputTypes["RegisterDeviceInput"]},ResolverInputTypes["RegisterDeviceOutput"]],
unregisterDevice?: [{	input: ResolverInputTypes["UnregisterDeviceInput"]},ResolverInputTypes["UnregisterDeviceOutput"]],
startSession?: [{	input: ResolverInputTypes["StartSessionInput"]},ResolverInputTypes["StartSessionOutput"]],
	deleteParentAccount?:ResolverInputTypes["DeleteParentAccountOutput"],
generateUploadUrl?: [{	input: ResolverInputTypes["GenerateUploadUrlInput"]},ResolverInputTypes["GenerateUploadUrlOutput"]],
		__typename?: boolean | `@${string}`
}>;
	["CompleteStepOutput"]: AliasType<{
	completedAt?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["CompleteStepInput"]: {
	profileId: ResolverInputTypes["ID"],
	lesson: number,
	task: number,
	step: number
};
	["CheckAnswerOutput"]: AliasType<{
	isCorrect?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["CheckAnswerInput"]: {
	story: string,
	question: string,
	receivedAnswer: string,
	prototypeAnswer: string
};
	["CheckPronunciationOutput"]: AliasType<{
	overall?:boolean | `@${string}`,
	pronunciation?:boolean | `@${string}`,
	fluency?:boolean | `@${string}`,
	integrity?:boolean | `@${string}`,
	words?:ResolverInputTypes["Word"],
	isCorrect?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["Word"]: AliasType<{
	word?:boolean | `@${string}`,
	score?:boolean | `@${string}`,
	phoneScore?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["CheckPronunciationInput"]: {
	audioBase64: string,
	refText: string,
	ageGroup: number
};
	["CheckWritingOutput"]: AliasType<{
	evaluation?:boolean | `@${string}`,
	storageKey?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["CheckWritingEvaluation"]:CheckWritingEvaluation;
	["CheckWritingInput"]: {
	referencePath: string,
	userPath: string,
	reference: string,
	type: ResolverInputTypes["CheckWritingType"]
};
	["CheckWritingType"]:CheckWritingType;
	["InitializePronunciationGraderOutput"]: AliasType<{
	provider?:boolean | `@${string}`,
	metadata?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["GraderProvider"]:GraderProvider;
	["InitializePronunciationGraderInput"]: {
	provider: ResolverInputTypes["GraderProvider"],
	metadata: ResolverInputTypes["AWSJSON"]
};
	["TextToSpeechOutput"]: AliasType<{
	id?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["TextToSpeechInput"]: {
	id: ResolverInputTypes["ID"],
	text: string,
	voiceId: string,
	stability?: number | undefined | null,
	similarityBoost?: number | undefined | null,
	style?: number | undefined | null,
	useSpeakerBoost?: boolean | undefined | null,
	model?: string | undefined | null
};
	["GenerateSpeechOutput"]: AliasType<{
	id?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["GenerateSpeechInput"]: {
	id: ResolverInputTypes["ID"],
	prompt: string,
	errorHandlingMessage?: string | undefined | null,
	options?: ResolverInputTypes["GenerateSpeechOptions"] | undefined | null
};
	["GenerateSpeechOptions"]: {
	voiceId: string,
	model?: string | undefined | null,
	stability?: number | undefined | null,
	similarityBoost?: number | undefined | null,
	style?: number | undefined | null,
	useSpeakerBoost?: boolean | undefined | null
};
	["SpeechOutput"]: AliasType<{
	id?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["TextToCharacterSpeechInput"]: {
	id: ResolverInputTypes["ID"],
	character: string,
	text: string
};
	["GenerateCharacterSpeechInput"]: {
	id: ResolverInputTypes["ID"],
	character: string,
	errorHandlingMessage?: string | undefined | null,
	promptOptions: ResolverInputTypes["PromptOptions"]
};
	["PromptOptions"]: {
	promptType: ResolverInputTypes["PromptType"],
	metadata: ResolverInputTypes["AWSJSON"]
};
	["PromptType"]:PromptType;
	["TextToSpeechChunk"]: AliasType<{
	id?:boolean | `@${string}`,
	chunk?:boolean | `@${string}`,
	order?:boolean | `@${string}`,
	isComplete?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["TextToSpeechChunkInput"]: {
	id: ResolverInputTypes["ID"],
	chunk: string,
	order: number,
	isComplete: boolean
};
	["CreateParentAccountOutput"]: AliasType<{
	success?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["CreateParentAccountInput"]: {
	email: string,
	password: string,
	preferredName: string
};
	["UpdateParentAccountOutput"]: AliasType<{
	success?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["UpdateParentAccountInput"]: {
	preferredName?: string | undefined | null
};
	["CreateChildProfileOutput"]: AliasType<{
	success?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["CreateChildProfileInput"]: {
	name: string,
	age: number,
	incorrectHelpThreshold: number
};
	["UpdateChildProfileOutput"]: AliasType<{
	success?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["UpdateChildProfileInput"]: {
	id: ResolverInputTypes["ID"],
	name?: string | undefined | null,
	age?: number | undefined | null,
	incorrectHelpThreshold?: number | undefined | null
};
	["RegisterDeviceOutput"]: AliasType<{
	success?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["RegisterDeviceInput"]: {
	userId: string,
	deviceId: string,
	token: string,
	platform: string
};
	["UnregisterDeviceOutput"]: AliasType<{
	success?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["UnregisterDeviceInput"]: {
	userId: string,
	deviceId: string
};
	["StartSessionOutput"]: AliasType<{
	sessionNumber?:boolean | `@${string}`,
	sessionStartedAt?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["StartSessionInput"]: {
	userId: string
};
	["DeleteParentAccountOutput"]: AliasType<{
	success?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["GenerateUploadUrlOutput"]: AliasType<{
	presignedUrl?:boolean | `@${string}`,
	key?:boolean | `@${string}`,
		__typename?: boolean | `@${string}`
}>;
	["GenerateUploadUrlInput"]: {
	uploadType: ResolverInputTypes["UploadType"],
	contentType: string,
	profileId: string,
	metadata: ResolverInputTypes["AWSJSON"]
};
	["UploadType"]:UploadType;
	["Subscription"]: AliasType<{
onTextToSpeechChunkReceived?: [{	id: ResolverInputTypes["ID"]},ResolverInputTypes["TextToSpeechChunk"]],
		__typename?: boolean | `@${string}`
}>;
	["schema"]: AliasType<{
	query?:ResolverInputTypes["Query"],
	mutation?:ResolverInputTypes["Mutation"],
	subscription?:ResolverInputTypes["Subscription"],
		__typename?: boolean | `@${string}`
}>;
	["ID"]:unknown
  }

export type ModelTypes = {
    ["Query"]: {
		getLastCompletedStep: ModelTypes["GetLastCompletedStepOutput"],
	getPronunciationGraderParameters: ModelTypes["GetPronunciationGraderParametersOutput"],
	me: ModelTypes["MeOutput"],
	listChildProfiles: ModelTypes["ListChildProfilesOutput"]
};
	["GetLastCompletedStepOutput"]: {
		lesson?: number | undefined | null,
	task?: number | undefined | null,
	step?: number | undefined | null,
	completedAt?: string | undefined | null
};
	["GetLastCompletedStepInput"]: {
	profileId: ModelTypes["ID"]
};
	["GetPronunciationGraderParametersOutput"]: {
		graderType: ModelTypes["GraderType"],
	parameters: ModelTypes["AWSJSON"]
};
	["GraderType"]:GraderType;
	/** The `AWSJSON` scalar type provided by AWS AppSync, represents a JSON string that complies with [RFC 8259](https://tools.ietf.org/html/rfc8259).  Maps like "**{\\"upvotes\\": 10}**", lists like "**[1,2,3]**", and scalar values like "**\\"AWSJSON example string\\"**", "**1**", and "**true**" are accepted as valid JSON and will automatically be parsed and loaded in the resolver mapping templates as Maps, Lists, or Scalar values rather than as the literal input strings.  Invalid JSON strings like "**{a: 1}**", "**{'a': 1}**" and "**Unquoted string**" will throw GraphQL validation errors. */
["AWSJSON"]:any;
	["GetPronunciationGraderParametersInput"]: {
	graderType: ModelTypes["GraderType"],
	refText: string
};
	["MeOutput"]: {
		parent: ModelTypes["Parent"]
};
	["Parent"]: {
		id: ModelTypes["ID"],
	preferredName: string,
	email: string
};
	["ListChildProfilesOutput"]: {
		childProfiles: Array<ModelTypes["ChildProfile"]>
};
	["ChildProfile"]: {
		id: ModelTypes["ID"],
	name: string,
	age: number,
	incorrectHelpThreshold: number
};
	["Mutation"]: {
		completeStep: ModelTypes["CompleteStepOutput"],
	checkAnswer: ModelTypes["CheckAnswerOutput"],
	checkPronunciation: ModelTypes["CheckPronunciationOutput"],
	checkWriting: ModelTypes["CheckWritingOutput"],
	initializePronunciationGrader: ModelTypes["InitializePronunciationGraderOutput"],
	textToSpeech: ModelTypes["TextToSpeechOutput"],
	generateSpeech: ModelTypes["GenerateSpeechOutput"],
	textToCharacterSpeech: ModelTypes["SpeechOutput"],
	generateCharacterSpeech: ModelTypes["SpeechOutput"],
	notifyTextToSpeechChunkReceived: ModelTypes["TextToSpeechChunk"],
	createParentAccount: ModelTypes["CreateParentAccountOutput"],
	updateParentAccount: ModelTypes["UpdateParentAccountOutput"],
	createChildProfile: ModelTypes["CreateChildProfileOutput"],
	updateChildProfile: ModelTypes["UpdateChildProfileOutput"],
	registerDevice: ModelTypes["RegisterDeviceOutput"],
	unregisterDevice: ModelTypes["UnregisterDeviceOutput"],
	startSession: ModelTypes["StartSessionOutput"],
	deleteParentAccount: ModelTypes["DeleteParentAccountOutput"],
	generateUploadUrl: ModelTypes["GenerateUploadUrlOutput"]
};
	["CompleteStepOutput"]: {
		completedAt?: string | undefined | null
};
	["CompleteStepInput"]: {
	profileId: ModelTypes["ID"],
	lesson: number,
	task: number,
	step: number
};
	["CheckAnswerOutput"]: {
		isCorrect: boolean
};
	["CheckAnswerInput"]: {
	story: string,
	question: string,
	receivedAnswer: string,
	prototypeAnswer: string
};
	["CheckPronunciationOutput"]: {
		overall: number,
	pronunciation: number,
	fluency: number,
	integrity: number,
	words: Array<ModelTypes["Word"]>,
	isCorrect: boolean
};
	["Word"]: {
		word: string,
	score: number,
	phoneScore: number
};
	["CheckPronunciationInput"]: {
	audioBase64: string,
	refText: string,
	ageGroup: number
};
	["CheckWritingOutput"]: {
		evaluation: ModelTypes["CheckWritingEvaluation"],
	storageKey: string
};
	["CheckWritingEvaluation"]:CheckWritingEvaluation;
	["CheckWritingInput"]: {
	referencePath: string,
	userPath: string,
	reference: string,
	type: ModelTypes["CheckWritingType"]
};
	["CheckWritingType"]:CheckWritingType;
	["InitializePronunciationGraderOutput"]: {
		provider: ModelTypes["GraderProvider"],
	metadata: ModelTypes["AWSJSON"]
};
	["GraderProvider"]:GraderProvider;
	["InitializePronunciationGraderInput"]: {
	provider: ModelTypes["GraderProvider"],
	metadata: ModelTypes["AWSJSON"]
};
	["TextToSpeechOutput"]: {
		id: ModelTypes["ID"]
};
	["TextToSpeechInput"]: {
	id: ModelTypes["ID"],
	text: string,
	voiceId: string,
	stability?: number | undefined | null,
	similarityBoost?: number | undefined | null,
	style?: number | undefined | null,
	useSpeakerBoost?: boolean | undefined | null,
	model?: string | undefined | null
};
	["GenerateSpeechOutput"]: {
		id: ModelTypes["ID"]
};
	["GenerateSpeechInput"]: {
	id: ModelTypes["ID"],
	prompt: string,
	errorHandlingMessage?: string | undefined | null,
	options?: ModelTypes["GenerateSpeechOptions"] | undefined | null
};
	["GenerateSpeechOptions"]: {
	voiceId: string,
	model?: string | undefined | null,
	stability?: number | undefined | null,
	similarityBoost?: number | undefined | null,
	style?: number | undefined | null,
	useSpeakerBoost?: boolean | undefined | null
};
	["SpeechOutput"]: {
		id: ModelTypes["ID"]
};
	["TextToCharacterSpeechInput"]: {
	id: ModelTypes["ID"],
	character: string,
	text: string
};
	["GenerateCharacterSpeechInput"]: {
	id: ModelTypes["ID"],
	character: string,
	errorHandlingMessage?: string | undefined | null,
	promptOptions: ModelTypes["PromptOptions"]
};
	["PromptOptions"]: {
	promptType: ModelTypes["PromptType"],
	metadata: ModelTypes["AWSJSON"]
};
	["PromptType"]:PromptType;
	["TextToSpeechChunk"]: {
		id: ModelTypes["ID"],
	chunk: string,
	order: number,
	isComplete: boolean
};
	["TextToSpeechChunkInput"]: {
	id: ModelTypes["ID"],
	chunk: string,
	order: number,
	isComplete: boolean
};
	["CreateParentAccountOutput"]: {
		success: boolean
};
	["CreateParentAccountInput"]: {
	email: string,
	password: string,
	preferredName: string
};
	["UpdateParentAccountOutput"]: {
		success: boolean
};
	["UpdateParentAccountInput"]: {
	preferredName?: string | undefined | null
};
	["CreateChildProfileOutput"]: {
		success: boolean
};
	["CreateChildProfileInput"]: {
	name: string,
	age: number,
	incorrectHelpThreshold: number
};
	["UpdateChildProfileOutput"]: {
		success: boolean
};
	["UpdateChildProfileInput"]: {
	id: ModelTypes["ID"],
	name?: string | undefined | null,
	age?: number | undefined | null,
	incorrectHelpThreshold?: number | undefined | null
};
	["RegisterDeviceOutput"]: {
		success: boolean
};
	["RegisterDeviceInput"]: {
	userId: string,
	deviceId: string,
	token: string,
	platform: string
};
	["UnregisterDeviceOutput"]: {
		success: boolean
};
	["UnregisterDeviceInput"]: {
	userId: string,
	deviceId: string
};
	["StartSessionOutput"]: {
		sessionNumber: number,
	sessionStartedAt: string
};
	["StartSessionInput"]: {
	userId: string
};
	["DeleteParentAccountOutput"]: {
		success: boolean
};
	["GenerateUploadUrlOutput"]: {
		presignedUrl: string,
	key: string
};
	["GenerateUploadUrlInput"]: {
	uploadType: ModelTypes["UploadType"],
	contentType: string,
	profileId: string,
	metadata: ModelTypes["AWSJSON"]
};
	["UploadType"]:UploadType;
	["Subscription"]: {
		onTextToSpeechChunkReceived?: ModelTypes["TextToSpeechChunk"] | undefined | null
};
	["schema"]: {
	query?: ModelTypes["Query"] | undefined | null,
	mutation?: ModelTypes["Mutation"] | undefined | null,
	subscription?: ModelTypes["Subscription"] | undefined | null
};
	["ID"]:any
    }

export type GraphQLTypes = {
    ["Query"]: {
	__typename: "Query",
	getLastCompletedStep: GraphQLTypes["GetLastCompletedStepOutput"],
	getPronunciationGraderParameters: GraphQLTypes["GetPronunciationGraderParametersOutput"],
	me: GraphQLTypes["MeOutput"],
	listChildProfiles: GraphQLTypes["ListChildProfilesOutput"]
};
	["GetLastCompletedStepOutput"]: {
	__typename: "GetLastCompletedStepOutput",
	lesson?: number | undefined | null,
	task?: number | undefined | null,
	step?: number | undefined | null,
	completedAt?: string | undefined | null
};
	["GetLastCompletedStepInput"]: {
		profileId: GraphQLTypes["ID"]
};
	["GetPronunciationGraderParametersOutput"]: {
	__typename: "GetPronunciationGraderParametersOutput",
	graderType: GraphQLTypes["GraderType"],
	parameters: GraphQLTypes["AWSJSON"]
};
	["GraderType"]: GraderType;
	/** The `AWSJSON` scalar type provided by AWS AppSync, represents a JSON string that complies with [RFC 8259](https://tools.ietf.org/html/rfc8259).  Maps like "**{\\"upvotes\\": 10}**", lists like "**[1,2,3]**", and scalar values like "**\\"AWSJSON example string\\"**", "**1**", and "**true**" are accepted as valid JSON and will automatically be parsed and loaded in the resolver mapping templates as Maps, Lists, or Scalar values rather than as the literal input strings.  Invalid JSON strings like "**{a: 1}**", "**{'a': 1}**" and "**Unquoted string**" will throw GraphQL validation errors. */
["AWSJSON"]: "scalar" & { name: "AWSJSON" };
	["GetPronunciationGraderParametersInput"]: {
		graderType: GraphQLTypes["GraderType"],
	refText: string
};
	["MeOutput"]: {
	__typename: "MeOutput",
	parent: GraphQLTypes["Parent"]
};
	["Parent"]: {
	__typename: "Parent",
	id: GraphQLTypes["ID"],
	preferredName: string,
	email: string
};
	["ListChildProfilesOutput"]: {
	__typename: "ListChildProfilesOutput",
	childProfiles: Array<GraphQLTypes["ChildProfile"]>
};
	["ChildProfile"]: {
	__typename: "ChildProfile",
	id: GraphQLTypes["ID"],
	name: string,
	age: number,
	incorrectHelpThreshold: number
};
	["Mutation"]: {
	__typename: "Mutation",
	completeStep: GraphQLTypes["CompleteStepOutput"],
	checkAnswer: GraphQLTypes["CheckAnswerOutput"],
	checkPronunciation: GraphQLTypes["CheckPronunciationOutput"],
	checkWriting: GraphQLTypes["CheckWritingOutput"],
	initializePronunciationGrader: GraphQLTypes["InitializePronunciationGraderOutput"],
	textToSpeech: GraphQLTypes["TextToSpeechOutput"],
	generateSpeech: GraphQLTypes["GenerateSpeechOutput"],
	textToCharacterSpeech: GraphQLTypes["SpeechOutput"],
	generateCharacterSpeech: GraphQLTypes["SpeechOutput"],
	notifyTextToSpeechChunkReceived: GraphQLTypes["TextToSpeechChunk"],
	createParentAccount: GraphQLTypes["CreateParentAccountOutput"],
	updateParentAccount: GraphQLTypes["UpdateParentAccountOutput"],
	createChildProfile: GraphQLTypes["CreateChildProfileOutput"],
	updateChildProfile: GraphQLTypes["UpdateChildProfileOutput"],
	registerDevice: GraphQLTypes["RegisterDeviceOutput"],
	unregisterDevice: GraphQLTypes["UnregisterDeviceOutput"],
	startSession: GraphQLTypes["StartSessionOutput"],
	deleteParentAccount: GraphQLTypes["DeleteParentAccountOutput"],
	generateUploadUrl: GraphQLTypes["GenerateUploadUrlOutput"]
};
	["CompleteStepOutput"]: {
	__typename: "CompleteStepOutput",
	completedAt?: string | undefined | null
};
	["CompleteStepInput"]: {
		profileId: GraphQLTypes["ID"],
	lesson: number,
	task: number,
	step: number
};
	["CheckAnswerOutput"]: {
	__typename: "CheckAnswerOutput",
	isCorrect: boolean
};
	["CheckAnswerInput"]: {
		story: string,
	question: string,
	receivedAnswer: string,
	prototypeAnswer: string
};
	["CheckPronunciationOutput"]: {
	__typename: "CheckPronunciationOutput",
	overall: number,
	pronunciation: number,
	fluency: number,
	integrity: number,
	words: Array<GraphQLTypes["Word"]>,
	isCorrect: boolean
};
	["Word"]: {
	__typename: "Word",
	word: string,
	score: number,
	phoneScore: number
};
	["CheckPronunciationInput"]: {
		audioBase64: string,
	refText: string,
	ageGroup: number
};
	["CheckWritingOutput"]: {
	__typename: "CheckWritingOutput",
	evaluation: GraphQLTypes["CheckWritingEvaluation"],
	storageKey: string
};
	["CheckWritingEvaluation"]: CheckWritingEvaluation;
	["CheckWritingInput"]: {
		referencePath: string,
	userPath: string,
	reference: string,
	type: GraphQLTypes["CheckWritingType"]
};
	["CheckWritingType"]: CheckWritingType;
	["InitializePronunciationGraderOutput"]: {
	__typename: "InitializePronunciationGraderOutput",
	provider: GraphQLTypes["GraderProvider"],
	metadata: GraphQLTypes["AWSJSON"]
};
	["GraderProvider"]: GraderProvider;
	["InitializePronunciationGraderInput"]: {
		provider: GraphQLTypes["GraderProvider"],
	metadata: GraphQLTypes["AWSJSON"]
};
	["TextToSpeechOutput"]: {
	__typename: "TextToSpeechOutput",
	id: GraphQLTypes["ID"]
};
	["TextToSpeechInput"]: {
		id: GraphQLTypes["ID"],
	text: string,
	voiceId: string,
	stability?: number | undefined | null,
	similarityBoost?: number | undefined | null,
	style?: number | undefined | null,
	useSpeakerBoost?: boolean | undefined | null,
	model?: string | undefined | null
};
	["GenerateSpeechOutput"]: {
	__typename: "GenerateSpeechOutput",
	id: GraphQLTypes["ID"]
};
	["GenerateSpeechInput"]: {
		id: GraphQLTypes["ID"],
	prompt: string,
	errorHandlingMessage?: string | undefined | null,
	options?: GraphQLTypes["GenerateSpeechOptions"] | undefined | null
};
	["GenerateSpeechOptions"]: {
		voiceId: string,
	model?: string | undefined | null,
	stability?: number | undefined | null,
	similarityBoost?: number | undefined | null,
	style?: number | undefined | null,
	useSpeakerBoost?: boolean | undefined | null
};
	["SpeechOutput"]: {
	__typename: "SpeechOutput",
	id: GraphQLTypes["ID"]
};
	["TextToCharacterSpeechInput"]: {
		id: GraphQLTypes["ID"],
	character: string,
	text: string
};
	["GenerateCharacterSpeechInput"]: {
		id: GraphQLTypes["ID"],
	character: string,
	errorHandlingMessage?: string | undefined | null,
	promptOptions: GraphQLTypes["PromptOptions"]
};
	["PromptOptions"]: {
		promptType: GraphQLTypes["PromptType"],
	metadata: GraphQLTypes["AWSJSON"]
};
	["PromptType"]: PromptType;
	["TextToSpeechChunk"]: {
	__typename: "TextToSpeechChunk",
	id: GraphQLTypes["ID"],
	chunk: string,
	order: number,
	isComplete: boolean
};
	["TextToSpeechChunkInput"]: {
		id: GraphQLTypes["ID"],
	chunk: string,
	order: number,
	isComplete: boolean
};
	["CreateParentAccountOutput"]: {
	__typename: "CreateParentAccountOutput",
	success: boolean
};
	["CreateParentAccountInput"]: {
		email: string,
	password: string,
	preferredName: string
};
	["UpdateParentAccountOutput"]: {
	__typename: "UpdateParentAccountOutput",
	success: boolean
};
	["UpdateParentAccountInput"]: {
		preferredName?: string | undefined | null
};
	["CreateChildProfileOutput"]: {
	__typename: "CreateChildProfileOutput",
	success: boolean
};
	["CreateChildProfileInput"]: {
		name: string,
	age: number,
	incorrectHelpThreshold: number
};
	["UpdateChildProfileOutput"]: {
	__typename: "UpdateChildProfileOutput",
	success: boolean
};
	["UpdateChildProfileInput"]: {
		id: GraphQLTypes["ID"],
	name?: string | undefined | null,
	age?: number | undefined | null,
	incorrectHelpThreshold?: number | undefined | null
};
	["RegisterDeviceOutput"]: {
	__typename: "RegisterDeviceOutput",
	success: boolean
};
	["RegisterDeviceInput"]: {
		userId: string,
	deviceId: string,
	token: string,
	platform: string
};
	["UnregisterDeviceOutput"]: {
	__typename: "UnregisterDeviceOutput",
	success: boolean
};
	["UnregisterDeviceInput"]: {
		userId: string,
	deviceId: string
};
	["StartSessionOutput"]: {
	__typename: "StartSessionOutput",
	sessionNumber: number,
	sessionStartedAt: string
};
	["StartSessionInput"]: {
		userId: string
};
	["DeleteParentAccountOutput"]: {
	__typename: "DeleteParentAccountOutput",
	success: boolean
};
	["GenerateUploadUrlOutput"]: {
	__typename: "GenerateUploadUrlOutput",
	presignedUrl: string,
	key: string
};
	["GenerateUploadUrlInput"]: {
		uploadType: GraphQLTypes["UploadType"],
	contentType: string,
	profileId: string,
	metadata: GraphQLTypes["AWSJSON"]
};
	["UploadType"]: UploadType;
	["Subscription"]: {
	__typename: "Subscription",
	onTextToSpeechChunkReceived?: GraphQLTypes["TextToSpeechChunk"] | undefined | null
};
	["ID"]: "scalar" & { name: "ID" }
    }
export enum GraderType {
	PHONEME = "PHONEME",
	WORD = "WORD",
	SENTENCE = "SENTENCE",
	LETTER_NAME = "LETTER_NAME"
}
export enum CheckWritingEvaluation {
	CORRECT = "CORRECT",
	INCORRECT = "INCORRECT",
	REVERSE = "REVERSE"
}
export enum CheckWritingType {
	LETTER = "LETTER"
}
export enum GraderProvider {
	SPEECHSUPER = "SPEECHSUPER"
}
export enum PromptType {
	ENCOURAGEMENT = "ENCOURAGEMENT"
}
export enum UploadType {
	USER_SOUND = "USER_SOUND"
}

type ZEUS_VARIABLES = {
	["GetLastCompletedStepInput"]: ValueTypes["GetLastCompletedStepInput"];
	["GraderType"]: ValueTypes["GraderType"];
	["AWSJSON"]: ValueTypes["AWSJSON"];
	["GetPronunciationGraderParametersInput"]: ValueTypes["GetPronunciationGraderParametersInput"];
	["CompleteStepInput"]: ValueTypes["CompleteStepInput"];
	["CheckAnswerInput"]: ValueTypes["CheckAnswerInput"];
	["CheckPronunciationInput"]: ValueTypes["CheckPronunciationInput"];
	["CheckWritingEvaluation"]: ValueTypes["CheckWritingEvaluation"];
	["CheckWritingInput"]: ValueTypes["CheckWritingInput"];
	["CheckWritingType"]: ValueTypes["CheckWritingType"];
	["GraderProvider"]: ValueTypes["GraderProvider"];
	["InitializePronunciationGraderInput"]: ValueTypes["InitializePronunciationGraderInput"];
	["TextToSpeechInput"]: ValueTypes["TextToSpeechInput"];
	["GenerateSpeechInput"]: ValueTypes["GenerateSpeechInput"];
	["GenerateSpeechOptions"]: ValueTypes["GenerateSpeechOptions"];
	["TextToCharacterSpeechInput"]: ValueTypes["TextToCharacterSpeechInput"];
	["GenerateCharacterSpeechInput"]: ValueTypes["GenerateCharacterSpeechInput"];
	["PromptOptions"]: ValueTypes["PromptOptions"];
	["PromptType"]: ValueTypes["PromptType"];
	["TextToSpeechChunkInput"]: ValueTypes["TextToSpeechChunkInput"];
	["CreateParentAccountInput"]: ValueTypes["CreateParentAccountInput"];
	["UpdateParentAccountInput"]: ValueTypes["UpdateParentAccountInput"];
	["CreateChildProfileInput"]: ValueTypes["CreateChildProfileInput"];
	["UpdateChildProfileInput"]: ValueTypes["UpdateChildProfileInput"];
	["RegisterDeviceInput"]: ValueTypes["RegisterDeviceInput"];
	["UnregisterDeviceInput"]: ValueTypes["UnregisterDeviceInput"];
	["StartSessionInput"]: ValueTypes["StartSessionInput"];
	["GenerateUploadUrlInput"]: ValueTypes["GenerateUploadUrlInput"];
	["UploadType"]: ValueTypes["UploadType"];
	["ID"]: ValueTypes["ID"];
}